"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mapContextToProps_1 = __importDefault(require("./mapContextToProps"));
function useMemorizedDispatch(dispatch, propsFromDispatch) {
    var _a;
    var result = propsFromDispatch;
    for (var _i = 0, _b = Object.keys(propsFromDispatch); _i < _b.length; _i++) {
        var prop = _b[_i];
        var dispatchFn = propsFromDispatch[prop];
        var memoDispatch = react_1.useCallback(dispatchFn, [dispatch]);
        result = __assign(__assign({}, result), (_a = {}, _a[prop] = memoDispatch, _a));
    }
    return result;
}
function connectCtx(contextStore) {
    return function (mapStateToProps, mapDispatchToProps) {
        return function (Component) {
            var MemoComponent = react_1.memo(Component);
            return function (props) {
                var _a = react_1.useContext(contextStore), state = _a.state, dispatch = _a.dispatch;
                var propsFromState = mapContextToProps_1.default(state, props, mapStateToProps);
                var propsFromDispatch = mapContextToProps_1.default(dispatch, props, mapDispatchToProps);
                var dispatchUseCallback = useMemorizedDispatch(dispatch, propsFromDispatch);
                return (react_1.default.createElement(MemoComponent, __assign({}, props, propsFromState, dispatchUseCallback)));
            };
        };
    };
}
exports.default = connectCtx;
